/**
 * User API-to-Client Adapter
 *
 * Transforms UserDto from API into simplified ClientUser
 */

import moment from "moment";
import { UserDto, WorkingHoursDto } from "../../../../../api-client";
import { CalendarResource, ClientUser } from "../types";

export const adaptUserToCalendarResource = (
  user: UserDto,
  weeklyWorkDays?: WorkingHoursDto[],
  resourceTitle?: string,
  deltaMinutes?: number,
  warningCount?: number,
  yearDeltaMinutes?: number
): CalendarResource => {
  // display name is last, first and trimmed to max 20 chars
  const firstName = user.firstName || "";
  const lastName = user.lastName || "";
  const displayName = `${lastName}, ${firstName}`.trim().substring(0, 16);
  // Find valid work days for the selected date

  // Generate business hours from work days
  const businessHours =
    weeklyWorkDays && weeklyWorkDays.length > 0
      ? weeklyWorkDays.map((day: WorkingHoursDto) => {
         const dayOfWeek = moment(day.date).day();
          return {
            daysOfWeek: [dayOfWeek],
            startTime: moment(day.start).format("HH:mm"),
            endTime: moment(day.end).format("HH:mm"),
          };
        })
      : [
          {
            // daysOfWeek: [selectedDayIndex],
            startTime: "00:00",
            endTime: "00:05",
          },
        ];

  const resource: CalendarResource = {
    id: String(user.id!), // Ensure ID is a string for consistent sorting
    title: resourceTitle ? resourceTitle : displayName,
    businessHours: businessHours,
    extendedProps: {
      userId: user.id,
      deltaMinutes: deltaMinutes,
      yearDeltaMinutes: yearDeltaMinutes,
      warningCount: warningCount,
      // link was here ....
    },
  };

  return resource;
};

/**
 * JUST THEORETICAL; NOT USED
 * Transform API UserDto to simplified ClientUser
 */
export const adaptUserFromApi = (user: UserDto): ClientUser => {
  const firstName = user.firstName || "";
  const lastName = user.lastName || "";
  const fullName = `${firstName} ${lastName}`.trim();
  const displayName = firstName ? `${firstName[0]}.${lastName}` : lastName;

  return {
    id: user.id!,
    firstName,
    lastName,
    fullName,
    displayName,
  };
};
